import { BonusTransaction, Jackpot, Transaction } from 'react-easyrocket';
import dayjs from 'dayjs';
import {
  COMPLETED_NO_WAGER_JACKPOTS_LS,
  HIGH_PROBABILITY_CHANCE,
  INITIAL_INTERVAL_MS,
  JACKPOT_TYPE,
  MAX_REFETCH_INTERVAL,
  MIN_REFETCH_INTERVAL,
  PROBABILITY_IMPACT_FACTOR,
  SECONDS_TO_MILLISECONDS
} from '../constants';

export const getIntervalByJackpotProbability = (jackpots: Jackpot[]): number => {
  if (!Array.isArray(jackpots) || jackpots.length === 0) {
    return 0;
  }
  // Поиск поля probability с наибольшим значением среди объектов Jackpots в массиве
  const maxProbability = jackpots.reduce((max, { jackpotInfo }) => {
    const probability = jackpotInfo?.probability;
    if (!probability) return max;
    return Math.max(probability, max);
  }, 0);
  // Получение интервала, зависящего от процента выпадения джектопа с обработкой исключений
  // обработка исключений (0 процентов либо 91+ процентов)
  if (maxProbability === 0) return MAX_REFETCH_INTERVAL;

  if (maxProbability > HIGH_PROBABILITY_CHANCE) return MIN_REFETCH_INTERVAL;

  // Вычесление общего случая по формуле ниже
  return PROBABILITY_IMPACT_FACTOR * maxProbability + INITIAL_INTERVAL_MS;
};

/*  определяет, стоит ли показывать модалку джекпота, полученную из транзакций
 * и принимает колбэк открытия модального окна с джекпотом,
 * возвращает функцию, которая показывает модалку
 * и отмечает ее как показанную в localStorage (Принимает кол)
 */
export const openJackpotModalFromTransactions = (
  jackpots: Transaction[] | undefined,
  callback: (jackpot: Transaction) => void
) => {
  if (!jackpots?.length) return;

  const newestJackpot = jackpots[0];

  const completedJackpots: number[] = JSON.parse(
    localStorage.getItem(COMPLETED_NO_WAGER_JACKPOTS_LS) || '[]'
  );
  const isAlreadyShown = completedJackpots.includes(newestJackpot.id);
  const isCompletedToday = dayjs.unix(newestJackpot.dateComplete).isSame(dayjs(), 'day');

  if (!isAlreadyShown && isCompletedToday) {
    const updatedData = [newestJackpot.id, ...completedJackpots];
    localStorage.setItem(COMPLETED_NO_WAGER_JACKPOTS_LS, JSON.stringify(updatedData));
    callback(newestJackpot);
  }
};

/* Фунция для открытия модалки джекпота из бонусных транзакций */
export const openJackpotModalFromBonusesTransactions = (
  arrayBonusesTansactions: BonusTransaction[],
  callback: (jackpot: BonusTransaction) => void
) => {
  if (!(arrayBonusesTansactions.length > 0)) return;
  const bonusTransaction = arrayBonusesTansactions[0];
  if (bonusTransaction.type !== JACKPOT_TYPE) return;
  callback(bonusTransaction);
};

export const jackpotGameIdTransactions = (jackpots: Transaction[] | undefined) => {
  if (!jackpots?.length) return null; // Проверка наличия массива джекпотов и его длины

  const newestJackpot = jackpots[0]; // Получение новейшего джекпота из массива
  const gameId = newestJackpot.game?.id;
  if (!gameId) return null;

  const jackpotId = newestJackpot.id;
  const jackpotDateComplete = newestJackpot.dateComplete;

  const completedJackpots: number[] = (() => {
    const raw = localStorage.getItem(COMPLETED_NO_WAGER_JACKPOTS_LS);
    return raw ? JSON.parse(raw) : [];
  })();
  // Проверка на то, был показан джекпот до этого или нет
  const wasJackpotAlreadyShown = completedJackpots.includes(jackpotId);
  // Проверка на то, разыгрался джекпот текущей датой (сегодня) или нет
  const wasJackpotCompletedToday = dayjs(jackpotDateComplete * SECONDS_TO_MILLISECONDS).isSame(
    dayjs(),
    'day'
  );

  return !wasJackpotAlreadyShown && wasJackpotCompletedToday ? gameId : null;
};
